import React, { Component } from 'react';
import { ListLayout } from '../../../Menu/Stock/containers/Layout';
import { Box, TableBody, TableRow, TableCell, Typography } from '@material-ui/core';
import StackedStats from '../../../Menu/Stock/stats/Stats/StackedStats';

class CommercialStats extends Component {
    state = {  }
    render() {
        const { commercial } = this.props;
        // console.log('====================================');
        // console.log({commercial});
        // console.log('====================================');
        return (
            <Box>
                <StackedStats
                    {...this.props}
                />
            </Box>
        );
    }
}

export default CommercialStats;